<template>
  <b-nav-item-dropdown
    right
    style="max-width: 350px;"
    toggle-class="d-flex align-items-center dropdown-user-link"
    class="dropdown-user"
  >
    <template #button-content>
      <div class="d-sm-flex d-none user-nav">
        <p class="user-name font-weight-bolder mb-0">
          {{ (userData.first_name || userData.last_name) ? `${userData.first_name || ''} ${userData.last_name || ''}`.trim() : (userData.email || '') }}
        </p>
        <!-- <span class="user-status">{{ userData.roles[0] === 'TALENT-ADVISOR' ? 'SME-TALENT-ADVISOR' : userData.roles[0] }}</span> -->
        <span class="user-status">{{ userData.position_title || (userData.roles && userData.roles[0]) || '' }}</span>
      </div>
      <!-- No default slot: BAvatar overrides :src/:text whenever a default
           slot exists (even if its v-if child is false in Vue 2.6+). -->
      <b-avatar
        size="40"
        :src="avatarSrc || undefined"
        :text="avatarInitials || undefined"
        variant="light-primary"
        badge
        class="badge-minimal"
        badge-variant="success"
      />
    </template>

    <!--<b-dropdown-item
      :to="{ name: 'pages-profile'}"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>Profile</span>
    </b-dropdown-item>-->
    <!--<b-dropdown-item
      :to="{ name: 'apps-email' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="MailIcon"
        class="mr-50"
      />
      <span>Inbox</span>
    </b-dropdown-item>-->
    <b-dropdown-item
      :to="{ name: 'apps-tasks' }"
      link-class="d-flex align-items-center"
      v-if="$can('read','task_management')"
    >
      <feather-icon
        size="16"
        icon="CheckSquareIcon"
        class="mr-50"
      />
      <span>Tasks</span>
    </b-dropdown-item>
    <!-- Volume2Icon -->
    <!-- v-if="$can('read','employee_communication')" -->
    <b-dropdown-item
      :to="{ name: 'apps-emp-communication' }"
      link-class="d-flex align-items-center"
      v-if="$can('read','employee_communication')"
    >
      <feather-icon
        size="16"
        icon="Volume2Icon"
        class="mr-50"
      />
      <span>Communication</span>
    </b-dropdown-item>
    <!-- <b-dropdown-item
      :to="{ name: 'apps-emp-communication' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="160"
        icon="Volume2Icon"
        class="mr-50"
      />
      <span>Communication</span>
    </b-dropdown-item> -->
    <!-- v-if="$can('read','bulk_mailer')" -->
    <b-dropdown-item
      :to="{ name: 'apps-bulk-mailer' }"
      link-class="d-flex align-items-center"
      v-if="$can('read','bulk_mailer')"
    >
      <feather-icon
        size="16"
        icon="MailIcon"
        class="mr-50"
      />
      <span>Bulk Mailer</span>
    </b-dropdown-item>
    

    <b-dropdown-divider />

    <b-dropdown-item
      :to="{ name: 'pages-account-setting' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>Change Password</span>
    </b-dropdown-item>
    <b-dropdown-divider />
    <b-dropdown-item v-if="$can('read','admin') || $can('read','master') || $can('read','hr')"
      :to="{ name: 'apps-users-list' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="UserIcon"
        class="mr-50"
      />
      <span>Manage Users</span>
    </b-dropdown-item>
    <b-dropdown-item
      v-if="$can('read', 'org_chart')"
      :to="{ name: 'dashboard-org-chart' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="GitBranchIcon"
        class="mr-50"
      />
      <span>Organization Chart</span>
    </b-dropdown-item>
    <b-dropdown-item
      v-if="canSeeAdminSettings"
      :to="{ name: 'apps-admin-settings' }"
      link-class="d-flex align-items-center"
    >
      <feather-icon
        size="16"
        icon="SlidersIcon"
        class="mr-50"
      />
      <span>Admin Settings</span>
    </b-dropdown-item>

    <b-dropdown-item
      link-class="d-flex align-items-center"
      @click="logout"
    >
      <feather-icon
        size="16"
        icon="LogOutIcon"
        class="mr-50"
      />
      <span>Logout</span>
    </b-dropdown-item></b-nav-item-dropdown>
</template>

<script>
import {
  BNavItemDropdown, BDropdownItem, BDropdownDivider, BAvatar,
} from 'bootstrap-vue'
import { initialAbility } from '@/libs/acl/config'
import useJwt from '@/auth/jwt/useJwt'
import { avatarText } from '@core/utils/filter'
import { resetFcmRegistrationCache } from '@/utils/fcm-push'
import callAnalyticsService from '@/services/call-analytics-service'
import { canAccessAdminSettings } from '@/utils/admin-settings-permissions'

export default {
  components: {
    BNavItemDropdown,
    BDropdownItem,
    BDropdownDivider,
    BAvatar,
  },
  data() {
    return {
      // `JSON.parse(null)` (i.e. `localStorage.getItem('userData')` returning
      // `null` when missing/cleared) itself returns `null`, not `{}` — the
      // `|| {}` guard here is what makes every `userData.xxx` read below
      // safe. This can legitimately be null for the brief moment between
      // this component mounting and `mounted()` below redirecting to login
      // (or, previously, when the router guard let a logged-out session
      // reach the authenticated layout at all — see `src/router/index.js`
      // for the actual fix to that).
      userData: JSON.parse(localStorage.getItem('userData')) || {},
    }
  },
  computed: {
    // Only bind a real URL string. Empty / "null" / "undefined" made b-avatar
    // enter image mode with nothing to show. Broken URLs still fall back via
    // BAvatar's img error handler (clears localSrc → uses :text / person icon).
    avatarSrc() {
      const u = this.userData || {}
      const raw = u.avatar || u.profile_pic || u.photo
      if (typeof raw !== 'string') return null
      const src = raw.trim()
      if (!src || /^null$/i.test(src) || /^undefined$/i.test(src)) return null
      return src
    },
    // Initials from whatever name fields login actually stores. Prefer
    // first+last, then emp_name / fullName / name / username, then email local-part.
    // Always provide text so a failed image load can fall back to initials
    // (BAvatar clears localSrc on img error, then uses :text). Truncate to 2
    // chars so long multi-word names don't overflow the 40px avatar.
    avatarInitials() {
      const u = this.userData || {}
      const name = `${u.first_name || ''} ${u.last_name || ''}`.trim()
        || u.emp_name
        || u.fullName
        || u.name
        || u.username
        || (u.email ? String(u.email).split('@')[0] : '')
        || ''
      const initials = avatarText(name)
      return initials ? initials.slice(0, 2) : null
    },
    // Same gate as the former sidebar item (`adminSettingsAccess` → canAccessAdminSettings).
    canSeeAdminSettings() {
      return canAccessAdminSettings((action, subject) => this.$can(action, subject))
    },
  },
  methods: {
    logout() {
      // Remove userData from localStorage
      // ? You just removed token from localStorage. If you like, you can also make API call to backend to blacklist used token
      /*localStorage.removeItem(useJwt.jwtConfig.storageTokenKeyName)
      localStorage.removeItem(useJwt.jwtConfig.storageRefreshTokenKeyName)
      localStorage.removeItem(emp_id)
      localStorage.removeItem(expireIn)*/
      window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
      //console.log("called logout")
      resetFcmRegistrationCache()
      if (callAnalyticsService && typeof callAnalyticsService.clearSessionCaches === 'function') {
        callAnalyticsService.clearSessionCaches()
      }
      localStorage.clear();

      // Remove userData from localStorage
      //localStorage.removeItem('userData')

      // Reset ability — this was previously commented out, which left the
      // shared CASL `ability` singleton (`src/libs/acl/ability.js`) holding
      // the just-logged-out user's FULL abilities in memory (it's a module-
      // level object, never re-created on logout). Since `canNavigate()` in
      // `src/router/index.js` only checks ability rules, a still-fully-
      // permissive `ability` object could let the router allow navigation
      // to authenticated routes even though `isLoggedIn` is now false,
      // mounting the authenticated layout against the just-cleared
      // localStorage and crashing. Resetting it back to the safe defaults
      // here closes that gap (the router guard's own primary `isLoggedIn`
      // check is the real fix for this — see the comment there — this is
      // the defensive backstop for the ability side of the same bug).
      this.$ability.update(initialAbility)

      // Redirect to login page
      this.$router.push({ name: 'auth-login' })
    },
  },
  mounted() {
    const loggedInUser = localStorage.getItem('userData')
    if(!loggedInUser) {
      window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])
      //console.log("called logout")
      if (callAnalyticsService && typeof callAnalyticsService.clearSessionCaches === 'function') {
        callAnalyticsService.clearSessionCaches()
      }
      localStorage.clear();
      this.$ability.update(initialAbility)
      this.$router.push({ name: 'auth-login' })
    }
  }
}
</script>
